import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';

import styles from './dashboard.module.css';
import DashboardGrid from './components/dashboard-grid/dashboard-grid';
import DashboardNavigation from './components/dashboard-navigation/dashboard-navigation';
import DashboardHeader from 'components/dashboard/components/DashboardHeader';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';

const Dashboard = () => {
  const [scale, setScale] = useState(1);
  const { state } = useSamarthDashboardContext();

  useEffect(() => {
    const calculateScale = () => {
      const { innerHeight: windowHeight, innerWidth: windowWidth } = window;

      // Base dimensions (design reference)
      const baseHeight = 1080 - 160; // Deduct header height (80px)
      const baseWidth = 1920;

      // Adjusted height for scaling (accounting for fixed header)
      const adjustedHeight = windowHeight - 160;

      // Determine the smaller scaling factor so content always fits
      const heightScale = adjustedHeight / baseHeight;
      const widthScale = windowWidth / baseWidth;
      let newScale = Math.min(heightScale, widthScale);

      // Clamp the overall scale
      newScale = Math.max(0.5, Math.min(1.2, newScale));

      // Fine‑tune for mobile & tablet breakpoints
      if (windowWidth < 768) {
        newScale = Math.min(windowWidth / 375, adjustedHeight / 812) * 0.8;
      } else if (windowWidth < 1024) {
        newScale = Math.min(windowWidth / 768, adjustedHeight / 1024) * 0.9;
      }

      setScale(newScale);
    };

    calculateScale();
    window.addEventListener('resize', calculateScale);
    return () => window.removeEventListener('resize', calculateScale);
  }, []);


  return (
    <Box className={styles.dashboard}>
      <DashboardHeader weekCurrent={state.dashboardData.weekCurrent || ""}/>
      <Box
        className={styles.scaledWrapper}
        style={{
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          width: `${100 / scale}%`,
          height: `${Math.min(100 / scale, 101.2)}vh`,
          maxHeight: 'fit-content',
        }}
      >
        {/* Sticky navigation */}
        <Box className={styles.stickyHeader}>
          <DashboardNavigation />
        </Box>

        {/* Main content */}
        <main className={styles.main}>
          <DashboardGrid />
        </main>
      </Box>
    </Box>
  );
};

export default Dashboard;